<template>
  <div>
    <div class="row">
      <div class="col-xs-12">
        <div class="row center-xs">
          <div class="col-xs-12 cl-mine-shaft">
            <h3 class="h4 m0 lh35">
              {{ giftPartner ? $t('Recipient address') : $t('Your address') }}
            </h3>
          </div>
        </div>
      </div>
    </div>
    <div class="row pt20">
      <div class="col-xs-12">
        <div class="row">
          <!-- Cards -->
          <address-list class="shipping-block-list-checkout" />
          <!---->

          <div class="col-xs-12" v-if="currentUser && addresses.length">
            <div class="shipping-block-actions add-btn">
              <button class="shipping-block-actions-btn" @click="toggleNewAddressForm">
                {{ !shippingDetailsState.showNewAddressForm ? $t('Add a new address') : $t('Close') }}
              </button>
            </div>
          </div>

          <!-- New Address -->
          <div class="w-100" v-if="currentUser && shippingDetailsState.showNewAddressForm">
            <address-form @updated="shippingAddressUpdated" :other-receiver="otherReceiver" :stored-address="shipping" :add-main-address="true" />
            <mini-button-full @click.native="handleConfirm" class="confirm-btn">
              {{ $t('Confirm') }}
            </mini-button-full>
          </div>
          <!---->
        </div>
      </div>
    </div>
  </div>
</template>

<script async>
import { Shipping } from '@vue-storefront/core/modules/checkout/components/Shipping';
import { mapActions, mapGetters, mapState } from 'vuex';
import MiniButtonFull from 'theme/components/theme/MiniButtonFull.vue';

const AddressList = () => import(/* webpackChunkName: "vsf-address-list" */ 'theme/components/core/blocks/MyAccount/ShippingDetails/AddressList');
const AddressForm = () => import(/* webpackChunkName: "vsf-address-form" */ 'theme/components/core/blocks/Form/Customer/Shipping/AddressForm');

export default {
  name: 'Shipping',
  components: {
    AddressList,
    AddressForm,
    MiniButtonFull
  },
  mixins: [Shipping],
  data: () => ({
    selectedAddress: null
  }),
  computed: {
    ...mapState({
      currentUser: (state) => state.user.current
    }),
    ...mapGetters({
      partnerNaming: 'partners/getPartnerByCode',
      cartItems: 'cart/getCartItems',
      getGroupedByPartnerProducts: 'partners/getGroupedByPartnerProducts',
      allLocations: 'locations/getLocations',
      currentLocation: 'locations/getActiveLocation',
      getTotalDeliveryPrice: 'cart/getTotalDeliveryPrice'
    }),
    isDisabled () {
      if (this.shipping.shippingMethod === 'pickup') return false
      return this.$v.shipping.$invalid || this.shippingMethods.length <= 0
    },
    giftPartner () {
      return this.getGroupedByPartnerProducts.find(el => el.partner.code === 'gift')
    },
    isValid () {
      return (!!this.shipping.api_details && !!this.shipping.latitude && !!this.shipping.longitude && !this.shippingDetailsState.showNewAddressForm);
    }
  },
  methods: {
    ...mapActions({
      addCustomerAddress: 'address/create',
      makeDefault: 'address/makeDefault',
      updateShippingDetailsState: 'shipping/updateShippingDetailsState'
    }),
    toggleNewAddressForm () {
      if (!this.shippingDetailsState.showNewAddressForm) {
        this.updateShippingDetailsState({
          shipToMyAddress: false,
          showNewAddressForm: true
        })
      } else {
        this.selectedAddress = null;
        this.getActiveShippingAddressId(true);
      }
      this.useMyAddress()
    },
    saveNewAddressFlag () {
      this.setAddNewAddress(this.saveToMyAddress)
    },
    updatePhoneNumber (value, phone) {
      this.phoneWithoutCode = phone.hasOwnProperty('nationalNumber') ? phone.nationalNumber : ''
      this.shipping.phoneNumber = phone.number
    },
    shippingAddressUpdated (shipping) {
      this.selectedAddress = shipping;
    },
    async handleConfirm () {
      if (!this.selectedAddress) {
        await this.$store.dispatch('notification/spawnNotification', {
          type: 'error',
          message: this.$t('Address is not valid!'),
          action1: { label: this.$t('OK') }
        });
        this.$bus.$emit('address-autocomplete-validate');
        return
      }
      this.addCustomerAddress({
        address: {
          apartment: this.selectedAddress.apartment,
          city: this.selectedAddress.city,
          country: this.selectedAddress.country,
          country_code: this.selectedAddress.country_code,
          state: this.selectedAddress.state,
          street: this.selectedAddress.street,
          house: this.selectedAddress.house,
          postcode: this.selectedAddress.postcode,
          api_details: this.selectedAddress.api_details,
          latitude: this.selectedAddress.latitude,
          longitude: this.selectedAddress.longitude,
          default_shipping: true,
          customer_id: this.currentUser.id,
          firstname: this.currentUser.firstname,
          lastname: this.currentUser.lastname,
          phone_number: this.currentUser.telephone
        }
      }).then(async res => {
        await this.$store.dispatch('notification/spawnNotification', {
          type: 'success',
          message: this.$t('Your address is added!'),
          action1: {label: this.$t('OK')}
        })
        this.selectedAddress = null;
        if (res.id && res.default_shipping) {
          await this.makeDefault({address_id: res.id});
          this.$bus.$emit('checkout-after-shippingDetails', res);
          this.$bus.$emit('checkout-after-shippingset', res);

          await this.$store.dispatch('address/addQuoteAddress', res);
          await this.$store.dispatch('cart/load');
          await this.updateShippingDetailsState({
            shipToMyAddress: true,
            showNewAddressForm: false
          })
        }
      })
    },
    validate () {
      this.$bus.$emit('address-autocomplete-validate');
    }
  }
}
</script>

<style scoped lang="scss">
.confirm-btn {
  margin: 16px 8px 0;
}

  .shipping-method {
    width: 100%;
  }

  .base-input-additional-text {
    min-height: 3rem;
  }

  .notif{
    position: relative;
    border: 1px solid #f5a623;
    padding-left: 35px;

    .notif-corner{
      color: #fff;
      position: absolute;
      left: 0;
      top: 0;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 38px 38px 0 0;
      border-color: #f5a423 transparent transparent transparent;
    }
    span.notif-text{
      position: absolute;
      left: 8px;
      font-size: 16px;
      top: 3px;
      color: #fff;
    }
  }
  .shipping-block-list-item-details {
    text-align: left;
  }
  .left-pos {
    text-align: left;
    margin-bottom: 20px;
  }
  .shipping {
    display: flex;
    flex-direction: column;

    &-line {
      height: 60px;
      margin-bottom: 20px;

      display: flex;
      justify-content: space-between;
      align-items: center;

      &.activated {
        height: 60px;
        margin-bottom: 20px;
      }

      @media only screen and (max-width: 768px) {
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
      }

      @media only screen and (max-width: 576px) {
        height: 0px;
        margin-bottom: 0;
      }

      &-title {
        margin: 0;

        color: #111;
        font-size: 20px;
        font-weight: 600;

        @media only screen and (max-width: 576px) {
          display: none;
        }
      }

      &-link {
        display: inline-flex;
        justify-content: space-between;
        align-items: center;

        @media only screen and (max-width: 768px) {
          font-size: 14px;
        }

        &-icon {
          padding-left: 10px;
        }
      }
    }

    &-block {
      &-nothing {
        width: 100%;
        margin-top: 10px;
        text-align: center;

        &-text {
          color: #111;
          font-size: 18px;
          font-weight: 400;
        }
      }

      &-actions {
        display: flex;
        justify-content: center;

        &.add-btn {
          justify-content: flex-start;

          & .shipping-block-actions-btn {
            padding-left: 98px;
            margin-bottom: 20px;

            background-image: url('../../../../assets/account/icon-location-active.png');
            background-position: 70px center;
            background-size: 15px 18px;
            background-repeat: no-repeat;

            @media only screen and (max-width: 768px) {
              width: 100%;
              padding: 16px 0 16px 20px;
              background-position: 50px center;
            }

            @media only screen and (max-width: 576px) {
              padding: 16px 84px 16px 98px;
              background-position: 70px center;
            }

            @media only screen and (max-width: 371px) {
              width: 100%;
              padding: 16px 0;
              background-size: 0;
            }
          }
        }

        &-btn {
          width: auto;
          padding: 16px 84px;

          color: #fff;
          font-size: 16px;
          font-weight: 400;

          background-color: #11bb2e;
          border: none;
          border-radius: 5px;

          outline: none;

          &:hover {
            cursor: pointer;
            background-color: rgba(17, 187, 46, 0.8);
          }
        }
      }

      &-field {
        padding: 0;
      }

      &-list-checkout {
        margin: 0 8px 24px;
      }
    }
  }
</style>

<style lang="scss">
  .shipping-address {
    width: 100%;
    .vti__dropdown {
      left: 5px;
    }
  }
</style>
